import React from 'react';
import {
  AccountCircle as AccountCircleIcon,
  Tv as TvIcon,
  PeopleAlt as PeopleAltIcon,
  List,
  Help,
} from '@mui/icons-material';
import {
  TapIcon,
  InventoryIcon,
  JarIcon,
  FiltersIcon,
  CalculatorIcon,
  ExitIcon,
  ReportsIcon,
  HomeIcon,
  SystemHealthIcon,
  SprayBottleIcon,
} from 'assets/icons';

import permissions from 'services/permissions';
import { getRootStore } from 'models/root';

const { userStore, ui } = getRootStore();

const DesktopMenuItems = [
  {
    id: 'home',
    path: '/home',
    name: 'Settings.home',
    icon: <HomeIcon />,
  },
  {
    id: 'tap',
    path: '/on-tap',
    name: 'Settings.tap',
    icon: <TapIcon />,
    guard: (props = {}) => {
      const { leftMenu } = props || {};
      return Boolean(leftMenu);
    },
  },
  {
    id: 'inventory',
    path: '/inventory',
    name: 'Settings.inventory',
    icon: <InventoryIcon />,
    hasDivider: true,
    guard: (props = {}) => {
      if (permissions.allowManageInventory() || permissions.allowReadOnlyInventory()) {
        const { leftMenu } = props || {};
        return Boolean(leftMenu);
      }
      return false;
    },
  },
  {
    id: 'my-beverages',
    path: '/my-beverages',
    name: 'Settings.myBeverages',
    icon: <JarIcon />,
    guard: () => permissions.allowManageMyBeverages() || permissions.allowReadOnlyMyBeverages(),
  },
  {
    id: 'cleaning-management',
    path: '/cleaning-management',
    name: 'Settings.cleaningManagement',
    icon: <SprayBottleIcon />,
    guard: permissions.allowQualityManagement,
  },
  {
    id: 'system-health',
    path: '/system-health',
    name: 'Settings.systemHealth',
    icon: <SystemHealthIcon />,
    guard: permissions.allowQualityManagement,
  },
  {
    id: 'reports',
    path: '/reports',
    name: 'Settings.reports',
    icon: <ReportsIcon />,
    guard: permissions.allowManageReports,
  },
  {
    id: 'digital-menu',
    path: '/digital-menu',
    name: 'Settings.digitalMenu',
    icon: <TvIcon />,
    guard: permissions.allowDigitalMenu,
    hasDivider: true,
  },
  {
    id: 'activity-logs',
    path: '/activity-logs',
    name: 'Settings.activityLogs',
    icon: <List />,
    guard: permissions.allowBarManager,
  },
  {
    id: 'employees',
    path: '/employees',
    name: 'Settings.employees',
    icon: <PeopleAltIcon />,
    guard: () => ['BarTrack', 'Owner', 'Manager'].includes(userStore.currentRole?._role_name),
  },
  {
    id: 'system-configuration',
    path: '/system-configuration',
    name: 'Settings.systemConfiguration',
    icon: <FiltersIcon />,
    // guard: permissions.allowSystemConfiguration,
    hasDivider: true,
  },
  {
    id: 'calculator',
    name: 'Settings.calculator',
    icon: <CalculatorIcon />,
    hasDivider: true,
    isButton: true,
    mobileVisibility: true,
    action: () => {
      ui.setModalVisibility('calculator', true);
    },
  },
  {
    id: 'help-center',
    path: '/help-center',
    name: 'Settings.helpCenter',
    icon: <Help />,
    hasDivider: true,
    isLast: true,
  },
  {
    id: 'my-account',
    path: '/my-account',
    name: 'Settings.myAccount',
    icon: <AccountCircleIcon />,
    isBottom: true,
  },
  {
    id: 'log-out',
    path: '/auth/login',
    name: 'Settings.logOut',
    icon: <ExitIcon />,
    isButton: true,
    action: () => userStore.logout(),
  },
];

export default DesktopMenuItems;
